import React, { useEffect, useRef, useState } from 'react'
import { useLastLocation } from 'react-router-last-location'
import { inject, observer } from 'mobx-react'
import qs from 'qs'

import { HomeTemplate } from '@components/templates'
import { useStore } from '@utils/hooks'

import { IS_DEV, DOMAIN_URL_LENGTH } from '@consts'
import Axios from 'axios'
import { getRandomSubset } from '@utils/array'
import { useParams } from 'react-router-dom'

interface HomePageProps {
  recordStore: RecordStore;
  authStore: AuthStore;
  statsStore: StatsStore;
  rewardStore: RewardStore;
  articleStore: ArticleStore;
  inplamStore: InplamStore;
  match: Any;
  history: Any;
  location: Any;
}

const HomePage = ({
  match,
  history,
  location,
  recordStore,
  authStore,
  statsStore,
  rewardStore,
  articleStore,
  dataMapStore,
  inplamStore,
}: HomePageProps) => {
  const query = qs.parse(location.search, {
    ignoreQueryPrefix: true,
    // 문자열 맨 앞의 ?를 생력
  })

  const lastLocation = useLastLocation()

  const { lang = 'ko' } = useParams()

  /* store */
  const { useInitialLoading } = useStore()

  const { currentUser, likedAristList } = authStore

  const fetchBannerList = authStore.fetchBannerList || (() => {})

  const [bannerList, setBannerList] = useState([])
  const fetchNoticePopupList = authStore.fetchNoticePopupList || (() => {})
  const noticePopupList = authStore.noticePopupList || (() => {})

  const rewardList = rewardStore.rewardList || null

  const fetchRewardList = rewardStore.fetchRewardList || (() => {})

  const fetchTotalArticleList = articleStore.fetchTotalArticleList || (() => {})

  const totalArticleList = articleStore.totalArticleList || null

  const fetchArticleData = async () => {
    const options = {
      limit: 10,
      offset: 0,
      isPopularArticle: 1,
      sortBy: 'viewCount',
      languageCodeList: `${lang}`,
    }

    await fetchTotalArticleList(options)
  }

  const fetchBanner = async () => {
    const result = await fetchBannerList({
      typeList: 'HOME_REWARD_BANNER,HOME_QUIZ_BANNER,HOME_EVENT_BANNER',
    })

    if (result) {
      setBannerList(result)
    }
  }

  useEffect(() => {
    const fetchDatas = async () => {
      await Promise.all([
        fetchNoticePopupList({}),
        useInitialLoading(fetchBanner()),
        useInitialLoading(fetchArticleData()),
        useInitialLoading(
          fetchRewardList({
            __offset: 0,
            __limit: 20,
            isExpired: false,
          }),
        ),
      ])
    }

    fetchDatas()

    if (!currentUser) {
      localStorage.setItem('plam_current_page', location.pathname)
    }
  }, [])

  return (
    <>
      <HomeTemplate
        currentUser={currentUser}
        rewardList={rewardList}
        fetchRewardList={fetchRewardList}
        articleList={totalArticleList}
        noticePopupList={noticePopupList}
        history={history}
        bannerList={bannerList}
      />
    </>
  )
}

export default inject(
  'recordStore',
  'authStore',
  'statsStore',
  'articleStore',
  'inplamStore',
  'dataMapStore',
  'rewardStore',
)(observer(HomePage))
